import * as React from "react";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import { Typography } from "@mui/material";
import Stack from "@mui/material/Stack";
import Modal from "@mui/material/Modal";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import CartExportModal from "./CartExportModal";

import Tooltip from "@mui/material/Tooltip";
import Grid from "@mui/material/Grid";
import InsertLinkIcon from "@mui/icons-material/InsertLink";
import ToggleOnOutlinedIcon from "@mui/icons-material/ToggleOnOutlined";

import { useSelector, useDispatch } from "react-redux";

import CartTableView from "./CartTableView";

import NoItemsReturned from "./CartTableView/NoItemsReturned";

import { getDoisFromUids } from "../../Logic/getDoisFromUids";

import config from "../../config.json";

const { baseUrl } = config;

const theme = createTheme({
  palette: {
    neutral: {
      main: "#fff",
      contrastText: "#fff",
    },
  },
});

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 650,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

export default function BasicModal() {
  const dispatch = useDispatch();
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const idsOfItemsInCart = useSelector((state) => state.idsOfItemsInCart);

  const handleClickLinkIcon = () => {
    const dois = getDoisFromUids(idsOfItemsInCart);
    const queryParameter = dois.join(",");

    const link = `${baseUrl}?cartItems=${queryParameter}`;

    navigator.clipboard.writeText(link);

    dispatch({
      type: "SET_SNACKBAR_MESSAGE",
      payload: "Link copied to clipboard",
    });
    dispatch({
      type: "OPEN_SNACKBAR",
    });

    console.log({ idsOfItemsInCart, dois, queryParameter, link });
  };

  const handleClickToggleIcon = () => {
    const dois = getDoisFromUids(idsOfItemsInCart);
    const queryParameter = dois.join(",");

    const link = `${baseUrl}?endorsedVariables=${queryParameter}`;

    navigator.clipboard.writeText(link);

    dispatch({
      type: "SET_SNACKBAR_MESSAGE",
      payload: "Link copied to clipboard",
    });
    dispatch({
      type: "OPEN_SNACKBAR",
    });

    console.log({ idsOfItemsInCart, dois, queryParameter, link });
  };

  if (idsOfItemsInCart.length === 0) {
    return (
      <div>
        <ThemeProvider theme={theme}>
          <Tooltip title="View Cart">
            <IconButton
              color="neutral"
              aria-label="add to shopping cart"
              onClick={handleOpen}
            >
              <ShoppingCartIcon />
            </IconButton>
          </Tooltip>
        </ThemeProvider>
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <NoItemsReturned></NoItemsReturned>
          </Box>
        </Modal>
      </div>
    );
  }

  return (
    <div>
      <ThemeProvider theme={theme}>
        <Tooltip title="View Cart">
          <IconButton
            color="neutral"
            aria-label="add to shopping cart"
            onClick={handleOpen}
          >
            <ShoppingCartIcon />
          </IconButton>
        </Tooltip>
      </ThemeProvider>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Stack spacing={1}>
            <Grid container alignItems="center">
              <Grid item xs={9}>
                <Typography variant="h4">Cart</Typography>
              </Grid>
              <Grid item xs={1}>
                <Tooltip title="Get link to endorse variables in cart">
                  <IconButton onClick={handleClickToggleIcon}>
                    <ToggleOnOutlinedIcon></ToggleOnOutlinedIcon>
                  </IconButton>
                </Tooltip>
              </Grid>
              <Grid item xs={1}>
                <Tooltip title="Get link to save variables in cart">
                  <IconButton onClick={handleClickLinkIcon}>
                    <InsertLinkIcon></InsertLinkIcon>
                  </IconButton>
                </Tooltip>
              </Grid>
              <Grid item xs={1}>
                <CartExportModal></CartExportModal>
              </Grid>
            </Grid>
            <Stack direction="row"></Stack>
            <CartTableView></CartTableView>
          </Stack>
        </Box>
      </Modal>
    </div>
  );
}
